import {
  createRequestTypes,
  makeApiActionCreator,
  START,
  SUCCESS,
  ERROR,
} from '@actions/utils';
import * as api from '../api/search';

const namespace = 'SEARCH';

export const GEO_ROUTES_FETCH = createRequestTypes(
  `${namespace}/GEO_ROUTES_FETCH`,
);

//fetchGeoRoutes is not being used
export const fetchGeoRoutes = ({ payload }) => {
  return async dispatch => {
    try {
      dispatch({ type: GEO_ROUTES_FETCH[START] });
      const data = await api.fetchGeoRoutes(payload);
      dispatch({ type: GEO_ROUTES_FETCH[SUCCESS], data });

      return data;
    } catch (error) {
      dispatch({ type: GEO_ROUTES_FETCH[ERROR], error });
      throw error;
    }
  };
};

export const SEARCH_JOB_CREATE = createRequestTypes(
  `${namespace}/SEARCH_JOB_CREATE`,
);

export const createSearchJob = makeApiActionCreator(
  api.createSearchJob,
  SEARCH_JOB_CREATE[START],
  SEARCH_JOB_CREATE[SUCCESS],
  SEARCH_JOB_CREATE[ERROR],
);

export const SEARCH_JOB_DELETE = createRequestTypes(
  `${namespace}/SEARCH_JOB_DELETE`,
);

export const deleteSearchJob = makeApiActionCreator(
  api.deleteSearchJob,
  SEARCH_JOB_DELETE[START],
  SEARCH_JOB_DELETE[SUCCESS],
  SEARCH_JOB_DELETE[ERROR],
);

export const SET_CURRENT_SEARCH = `${namespace}/SET_CURRENT_SEARCH`;

export const setCurrentSearch = payload => ({
  type: SET_CURRENT_SEARCH,
  payload,
});

export const SET_SELECTED_ROUTE_METADATA = `${namespace}/SET_SELECTED_ROUTE_METADATA`;

export const setSelectedRouteMetadata = payload => ({
  type: SET_SELECTED_ROUTE_METADATA,
  payload,
});

export const SET_CURRENT_LOAD = `${namespace}/SET_CURRENT_LOAD`;

export const setCurrentLoad = payload => ({
  type: SET_CURRENT_LOAD,
  payload,
});

export const SET_CURRENT_USER_FILTER = `${namespace}/SET_CURRENT_USER_FILTER`;

export const setCurrentUserFilter = payload => ({
  type: SET_CURRENT_USER_FILTER,
  payload,
});

export const SET_DRAGGABLE_HEIGHT = `${namespace}/SET_DRAGGABLE_HEIGHT`;

export const setDraggableHeight = payload => ({
  type: SET_DRAGGABLE_HEIGHT,
  payload,
});

export const fetchTolls = payload => {
  return async dispatch => {
    try {
      dispatch({ type: TOLLS_FETCH, payload });
    } catch (error) {
      dispatch({ type: TOLLS_FETCH_ERROR, payload: error });
      throw error;
    }
  };
};

export const TOLLS_FETCH = `${namespace}/TOLLS_FETCH`;
export const TOLLS_FETCH_ERROR = `${namespace}/TOLLS_FETCH_ERROR`;
export const TOLLS_FETCH_SUCCESS = `${namespace}/TOLLS_FETCH_SUCCESS`;
